<template>
    <div class="edit_food_price" :data-indicador="indicador">
        <div :class="['food_item_price', food.discount_active ? 'discount_active' : '']" @click.prevent="activeEdit()" :data-indicador="indicador">
            <div :class="[food.discount_active ? 'with_discount' : '']">
                {{currency}} {{ food.price | formatMoney}}
            </div>
            <div v-if="food.discount_active && food.discount_percent > 0" class="food_item_price_discount">
                {{currency}} {{ (food.price - ((food.price*food.discount_percent)/100)) | formatMoney}}
            </div>
        </div>
        <div :class="['content-editor', editActive ? 'active' : '']" :data-indicador="indicador">
            <div class="label_amount">
                <label for="inputAmount">Price</label>
                <AmountInput v-model="food.price"
                    placeholder="E.g. 1.00"
                    :max="100000"
                    @save="saveFoodPrice()"
                    @keydown.enter.prevent="noEnter($event)"
                    class_input="price"
                    currency=""
                    :modo_calc="food.discount_active ? 'none' : 'amount'"
                />
            </div>
            <div class="onoffswitch discount_active">
                <input type="checkbox" class="onoffswitch-checkbox" :id="'modeCacl' + food.id"
                    :checked="food.discount_active"
                    @change="onModeCalcChange" />
                <label class="onoffswitch-label" :for="'modeCacl' + food.id">
                    <span class="onoffswitch-inner"></span>
                    <span class="onoffswitch-switch"></span>
                </label>
            </div>
            <div class="label_discount">
                <label for="inputPercent">Discount</label>
                <PercentInput v-model="food.discount_percent"
                    placeholder="E.g. 10%"
                    :max="99.99"
                    @save="saveFoodPrice()"
                    @keydown.enter.prevent="noEnter($event)"
                    class_input="price"
                    :modo_calc="food.discount_active ? 'percent' : 'none'"
                />
            </div>
            <button class="btn-event btn-close" @click.prevent="inactiveEdit(); saveFoodPrice();">
                <i class="fas fa-times"></i>
            </button>
            <!-- <input type="number" v-model="food.price"
            placeholder="E.g. 1.00"
            step="0.01"
            min="0"
            max="100000"
            ref="editPrice_food"
            @change="saveFoodPrice()"
            @focusout="inactiveEdit"
            class="price" > -->
            <span class="tooltip">Error, wrong format, maximum 2 decimals.</span>
        </div>
    </div>
</template>
<script>
import AmountInput from "@/apps/billing/components/calcManual/inputs/AmountInput.vue";
import PercentInput from "@/apps/billing/components/calcManual/inputs/PercentInput.vue";
import { mapGetters } from "vuex";
export default {
    components: {
        AmountInput,
        PercentInput,
    },
    props: ['indicador', 'food'],
    data(){
        return {
            loadSave: false,
            editActive: false,
            apis: null,
            currency: null,
            price_old: null,
        };
    },
    computed: {
        ...mapGetters("ModApps/Marketea/", {
            get_currency: "get_bmenu_currency",
        }),
    },
    watch: {
        get_currency(){
            this.currency = this.get_currency;
            // console.log('watch currency', this.currency)
        },
    },
    created(){
        let t = this;
        let urlApis = this.$store.getters['ModApps/Marketea/urlApis'];
        this.apis = urlApis.bMenu;
        this.currency = this.$store.getters['ModApps/Marketea/get_bmenu_currency'];
        this.price_old = this.food.price
        // console.log('created currency', this.currency)
    },
    methods: {
        activeEdit(){
            let t = this;
            t.editActive = true;
            setTimeout(() => {
                if(t.$refs.editPrice_food){
                    t.$refs.editPrice_food.focus();
                }
            }, 200);
        },
        inactiveEdit(){
            console.log('inactiveEdit');
            this.editActive = false;
        },
        noEnter(e){
            let t = this;
            var code = (e.which) ? e.which : e.keyCode;
            if(code == 13){
                e.preventDefault();
                t.inactiveEdit();
                t.saveFoodPrice()
            }
        },
        saveFoodPrice(){
            let t= this;
            let urlService = t.apis.set(3)// setFood
            if(t.isEmptyNaN(t.food.price)){
                t.$notify({
                    group: "noti",
                    type: "error",
                    title: "Error",
                    text: "Incorrect amount.",
                });
                t.food.price = t.price_old;
            }else{
                if(!t.loadSave){
                    t.loadSave = true;
                    // @ts-ignore
                    window.master.post(urlService, t.food)
                    .then((response) => {
                        console.log(urlService, t.food, response.data);
                        t.loadSave = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        t.loadSave = false;
                        t.$notify({
                            group: "noti",
                            type: "error",
                            title: "Error",
                            text: "Could not be save!",
                        });
                    });
                }
            }
        },
        onModeCalcChange(e){
            this.food.discount_active = Number(e.target.checked); // convert boolean to 0 or 1
            this.saveFoodPrice();
        },
        convertToNumeric(val){
            let num;
            if (typeof val === "boolean") {
            // Caso: ya es boolean
            num = Number(val);
            } else if (typeof val === "string") {
            // Caso: es string, validamos contenido
            num = (val.toLowerCase() === "true") ? 1 : 0;
            } else {
            // Otro tipo, opcional
            num = 0;
            }
            return num;
        },
        isEmptyNaN(val){
            if (isNaN(val)){ return true;}
            else if (val==null){ return true;}
            else if (val==''){ return true;}
            else{ return false;}
        },
    }
}
</script>
<style lang="scss" scoped>
    .edit_food_price {
        .food_item_price{
            border: 1px dashed transparent;
            &.discount_active{
                display: flex;
                align-items: center;
                gap: 0px 25px;
            }
            &:hover{
                border: 1px dashed #fcd602;
            }
            .with_discount {
                opacity: 0.3;
                text-decoration: line-through;
                font-size: 1rem;
                color: #e56045;
            }
            .food_item_price_discount {
                position: relative;
                &:before {
                    content: "";
                    position: absolute;
                    top: 50%;
                    left: -15px;
                    transform: translateY(-50%);
                    width: 0;
                    height: 0;
                    border-top: 6px solid transparent;
                    border-bottom: 6px solid transparent;
                    border-left: 10px solid #555;
                }
            }
        }
        .content-editor {
            display: none;
            &.active {
                display: flex;
                align-items: center;
                position: relative;
                width: 300px;
                gap: 10px 15px;
            }
            margin-top: 10px;
            margin-bottom: 50px;
            .label_amount, .label_discount {
                display: flex;
                flex-direction: column;
                label {
                    font-size: 12px;
                    margin-bottom: 0px;
                    line-height: 1;
                }
            }
            .onoffswitch.discount_active {
                margin: 0;
                .onoffswitch-inner:before {
                    padding-left: 10px;
                }
            }
            button.btn-event.btn-close {
                right: 0;
            }
            input.price {
                width: 80px;
                text-align: right;
                -moz-appearance: textfield;
                border: 0px;
                border-bottom: 1px solid #ddd;
                &:focus {
                    outline: none;
                }
                &[readonly="readonly"] {
                    border-bottom: 1px dashed #ddd;
                    cursor: not-allowed;
                    opacity: 0.2;
                }
                &::-webkit-inner-spin-button,
                &::-webkit-outer-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }
            }
        }
    }
</style>
